import { localeHandler } from '../utils';

export default {
  /**
   * storeのみを元にログイン状態を判別。下記はfalse
   * - ''
   * -
   * - null
   * - undefined
   * - 0
   */
  getCurrentCampaign: state => {
    return state.current.campaign;
  },
  getEnumByCode: state => ({ type, code }) => {
    let textProp = 'textJa';
    if (localeHandler.getLocale() === 'en') {
      textProp = 'textEn';
    }
    if (state.apiEnums[type] && state.apiEnums[type][code]) {
      return state.apiEnums[type][code][textProp];
    } else {
      return false;
    }
  },
  getEnumsObjByType: state => type => {
    if (state.apiEnums[type]) {
      return state.apiEnums[type];
    } else {
      return {};
    }
  },
  getEnumsArrayByType: state => type => {
    if (state.apiEnums[type]) {
      return Object.values(state.apiEnums[type]);
    } else {
      return [];
    }
  }
};
